export class AuthChallengeModel {
    clientId: string;
    codeChallenge: string;
    codeChallengeMethod: string;
}
